import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { IoClose } from 'react-icons/io5';
import { useAppConfig } from '../../../hooks/use-app-config';
import { useCheckout } from '../../../hooks/use-checkout';

export function ErrorMessage({ handleClose }: { handleClose: () => void }) {
  const { t } = useTranslation(undefined, { keyPrefix: 'checkout' });
  const { featureFlags } = useAppConfig();
  const { redirectUrl } = useCheckout();

  const showReturnToGame = Boolean(redirectUrl);

  return (
    <div className="success-wrapper">
      <section className="success">
        {!featureFlags?.checkout_deeplinks_disable_store && !redirectUrl && (
          <div className="close-icon" onClick={handleClose}>
            <IoClose size={24} color="white" />
          </div>
        )}
        <motion.h1>{t('ohNo')}</motion.h1>
        <motion.h4>{t('somethingWentWrong')}</motion.h4>
        {showReturnToGame && (
          <button
            className="redirect-button"
            style={{
              backgroundColor: 'white',
              color: 'black',
              marginTop: '1em',
              width: 'fit-content',
            }}
            onClick={handleClose}
          >
            {t('returnToGame')}
          </button>
        )}
      </section>
    </div>
  );
}
